export interface NumberedQuestion {
    id: string;
    type?: string;
    subQuestions?: Array<{ id: string }>;
}

/** The sub-questions a passage expands into, or null when the question takes a single number. */
export const expandedSubQuestions = (question: NumberedQuestion, expand: boolean) =>
    expand && question.type === 'PASSAGE' && question.subQuestions?.length ? question.subQuestions : null;

/** How many numbers a question takes in the navigator: a passage spans its sub-questions when `expand` is on. */
export const questionItemCount = (question: NumberedQuestion, expand: boolean): number =>
    expandedSubQuestions(question, expand)?.length ?? 1;

/** `starts[i]` is the 1-based number of question i's first item; `total` is the count of numbered items. */
export function questionNumbering(questions: NumberedQuestion[], expand: boolean) {
    const starts: number[] = [];
    let total = 0;
    for (const question of questions) {
        starts.push(total + 1);
        total += questionItemCount(question, expand);
    }
    return { starts, total };
}
